import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  
  // Check if user is logged in
  const isLoggedIn = !!localStorage.getItem('authToken');
  
  // If not logged in, redirect to login page with return url
  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // If logged in, render the protected component
  return children;
};

export default ProtectedRoute;
